import React from 'react'

export const AuthorizedConfiguration: React.FC = React.memo((props) => {
  // 请求登录
  const { children } = props
  return <>{children}</>
})

AuthorizedConfiguration.displayName = 'AuthorizedConfiguration'
